module.exports = __webpack_public_path__ + "static/photoshop-e232e8029a7d08bddc202f4e165c0de7.png";